/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_itemSearch$ref = any;
export type SbSharedRefineMenuFilterCreator_itemSearch$ref = any;
export type SbSharedRefineMenuFilterCreator_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterCreator_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuFilterCreator_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'a5e1f31635dce59cd808ba4f0162a697';
export default node;
